import vue from 'vue'

const tables = ['glbObjectStatus']

import batch from '../../common/batch-load'

import mapClassifier from '../../common/mapClassifier'

export default {
    actions: {
        retrieve(ctx) {
            if (ctx.state.globalLoadStatus) return


            ctx.commit('changeGlobalLoadStatus', false)
            return batch(tables, (row) => `/${row}`, 50, ctx.state.configGlobal(ctx))
        }
    },
    state: {
        globalDicts: Object.fromEntries(tables.map(row => [row, []])),
        globalLoadStatus: false,
        configGlobal(ctx) {
            return {
                onComplete({ row, response }) {
                    ctx.commit('setValue', { row, result: response.data.Data })
                },
                onError({ row, reason }) {
                    console.error(reason);
                },
                onBatchComplete(resolved) {
                    ctx.commit('changeGlobalLoadStatus', true)
                }
            }
        }
    },
    mutations: {
        setValue(state, { row, result }) {
            state.globalDicts[row] = result
        },

        changeGlobalLoadStatus(state, status) {
            state.globalLoadStatus = status
        },
    },
    getters: {
        globalLoadStatus: (state) => state.globalLoadStatus,

        glbObjectStatus(state) {
            return state.globalDicts.glbObjectStatus
        }
    }
}